export enum LOCAL_STORAGE_DATA {
  ACCESS_TOKEN = "accessToken",
  USER = "user",
  USER_APPLE_CREDENTIALS = "userAppleCredentials",
  PUSH_NOTIFICATION_TOKEN = "pushNotificationToken",
  FIRST_TIME = "first_time",
  THEME = "theme",
  APP_LANGUAGE_CODE = "appLanguageCode",
  IS_FIRST_TIME_VISITING_COMMUNITIES_PAGE = "isFirstTimeVisitingCommunitiesPage",
  IS_FIRST_TIME_DOING_A_SUPERLIKE = "isFirstTimeDoingASuperLike",
  IS_FIRST_TIME_DOING_A_REWARDING_ACTION = "isFirstTimeDoingARewardingAction",
}
export class LocalStorageController {
  private static instance: LocalStorageController | null = null;
  constructor() {
    LocalStorageController.instance = this;
  }
  static connect() {
    if (LocalStorageController.instance) {
      return LocalStorageController.instance;
    }
    return new LocalStorageController();
  }
  storeData(key: LOCAL_STORAGE_DATA, value: string) {
    localStorage.setItem(key, value);
  }

  getData(
    key: LOCAL_STORAGE_DATA,
    dataType: "bool" | "string" = "string"
  ): string | null {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }
  async deleteData(key: LOCAL_STORAGE_DATA) {
    localStorage.removeItem(key);
  }
}
